import React, { useEffect, useState } from 'react';
import {
  Container,
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import './header.scss'
import { useTranslation } from 'react-i18next';
import {logout} from '../../store/actions/auth.actions'
import {useDispatch, useSelector} from 'react-redux';
import {useHistory, Link, NavLink} from 'react-router-dom';
import ContactModal from '../../components/ContactModal/ContactModal';
import {user} from "../../store/actions/auth.actions";

const Header = () => {
  const dispatch = useDispatch()
  const history = useHistory();
  const { t, i18n } = useTranslation()
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const toggleNavigation = () => {
    setIsNavigationOpen(!isNavigationOpen)
  }

  const onLanguageChange = (lang) => {
    i18n.changeLanguage(lang)
    localStorage.setItem('language', lang);
  }

  const handleLogout = () => {
    dispatch(logout())
    history.push("/login")
  }

  const auth_user = useSelector((state) => state.auth.user);

  useEffect(() => {
    dispatch(user());
  }, [])

  const [contactModal, setContactModal] = useState(false);
  const toggleContactModal = () => setContactModal(!contactModal);

  return (
    <>
      <ContactModal toggleContactModal={toggleContactModal} isOpen={contactModal} />

      <header className="header">
        <Container>
          <Navbar dark expand="md">
            <NavbarToggler onClick={toggleNavigation} />
            <Collapse isOpen={isNavigationOpen} navbar>
              <Nav className="ml-auto" navbar>
                {/* <NavItem>
                  <NavLink exact to="/" className="nav-link" activeClassName="active">{t('navigationItemHome')}</NavLink>
                </NavItem> */}
                {/* <NavItem>
                  <NavLink to="/register" className="nav-link" activeClassName="active">{t('navigationItemRegister')}</NavLink>
                </NavItem> */}
                <NavItem>
                  <NavLink to="/lobby" className="nav-link" activeClassName="active">{t('navItemLobby')}</NavLink>
                </NavItem>
                <NavItem>
                <NavLink to="/booths" className="nav-link" activeClassName="active">{t('navItemBooths')}</NavLink>
                </NavItem>
                <NavItem>
                <NavLink to="/greenforums" className="nav-link" activeClassName="active">{t('navItemGreenForums')}</NavLink>
                </NavItem>
                <NavItem>
                  <span className="nav-link"style={{cursor: 'pointer'}}  onClick={toggleContactModal}>{t('navigationItemContact')}</span>
                </NavItem>
                <NavItem className="ml-md-5">
                  {i18n.language === 'en' ?
                    <span style={{cursor: 'pointer'}} className="nav-link" onClick={() => onLanguageChange('sq')}>Albanian</span>
                  :
                    <span style={{cursor: 'pointer'}} className="nav-link" onClick={() => onLanguageChange('en')}>English</span>}
                </NavItem>
                <NavItem><UncontrolledDropdown>
                  <DropdownToggle caret className="nav-link" nav>
                    {t('navigationItemAccount')}
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem header>{auth_user && auth_user.fullName}</DropdownItem>
                    <DropdownItem header>{auth_user && auth_user.email}</DropdownItem>
                    <DropdownItem onClick={() => handleLogout()}>{isAuthenticated &&
                    <Link className="logoutNav" to="">{t('navItemLogout')}</Link>}</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                </NavItem>
              </Nav>
            </Collapse>
          </Navbar>
        </Container>
      </header>
    </>
  );
}

export default Header;